// extracted by mini-css-extract-plugin
export var latestArticle = "index-module--latestArticle--3M8Ex";
export var title = "index-module--title--3qZ-l";
export var tutorial = "index-module--tutorial--3JuvP";
export var cardList = "index-module--cardList--2rkgp";